document.addEventListener('DOMContentLoaded', function () {

  const container = document.getElementById('qr-rows-container');
  const addMoreBtn = document.querySelector('.qr-add-more');
  const emptyMsg = document.getElementById('qr-empty-msg');

  function actualizarEstadoVacio() {
    const filas = container.querySelectorAll('.qr-row');
    if (emptyMsg) emptyMsg.style.display = filas.length === 0 ? 'block' : 'none';
  }

  function initRow(row) {
    row.querySelector('.qr-qty__minus')?.addEventListener('click', function () {
      const input = row.querySelector('.qr-qty__input');
      const min = parseInt(input.getAttribute('min') || 0);
      if (parseInt(input.value) > min) input.value = parseInt(input.value) - 1;
    });
    row.querySelector('.qr-qty__plus')?.addEventListener('click', function () {
      const input = row.querySelector('.qr-qty__input');
      input.value = parseInt(input.value || 0) + 1;
    });
    row.querySelector('.qr-row__del')?.addEventListener('click', function () {
      const nombre = row.querySelector('.qr-row__name')?.textContent.trim()
        || row.querySelector('.qr-product-selector')?.options[row.querySelector('.qr-product-selector')?.selectedIndex]?.text;
      row.remove();
      actualizarEstadoVacio();
      let cotizacion = JSON.parse(localStorage.getItem('qr_cotizacion') || '[]');
      cotizacion = cotizacion.filter(function(p) { return p.nombre !== nombre; });
      localStorage.setItem('qr_cotizacion', JSON.stringify(cotizacion));
    });
  }

  function renderVariantCell(cell, variantes, selectedColor, imgEl) {
    cell.innerHTML = '';
    if (!variantes || !variantes.length) {
      const inp = document.createElement('input');
      inp.type = 'text';
      inp.className = 'qr-variant-input qr-input';
      inp.placeholder = 'Color / variante';
      inp.value = selectedColor || '';
      inp.style.cssText = 'font-size:0.82rem;padding:5px 8px;border:1px solid #ddd;border-radius:5px;width:100%;';
      cell.appendChild(inp);
      return;
    }

    const activeColor = selectedColor || variantes[0].color;

    const select = document.createElement('select');
    select.className = 'qr-variant-input';
    select.style.cssText = 'font-size:0.82rem;padding:5px 8px;border:1px solid #ddd;border-radius:5px;width:100%;cursor:pointer;';

    variantes.forEach(function(v) {
      const opt = document.createElement('option');
      opt.value = v.color;
      opt.textContent = v.color;
      opt.dataset.img = v.img || '';
      if (v.color === activeColor) opt.selected = true;
      select.appendChild(opt);
    });

    select.addEventListener('change', function() {
      const opt = select.options[select.selectedIndex];
      if (opt.dataset.img && imgEl) imgEl.src = opt.dataset.img;
    });

    cell.appendChild(select);
  }

  function crearFila(producto) {
    const row = document.createElement('div');
    row.className = 'qr-row';
    row.dataset.dynamic = 'true';

    const imgEl = document.createElement('img');
    imgEl.src = producto.img || '';
    imgEl.alt = producto.nombre || '';
    imgEl.style.cssText = 'width:52px;height:52px;object-fit:cover;border-radius:6px;border:1px solid #eee;flex-shrink:0;';

    const colProducto = document.createElement('div');
    colProducto.className = 'qr-row__product';
    const innerWrap = document.createElement('div');
    innerWrap.style.cssText = 'display:flex;gap:10px;align-items:flex-start;';
    const textWrap = document.createElement('div');
    textWrap.style.cssText = 'display:flex;flex-direction:column;gap:2px;justify-content:center;';
    const nameEl = document.createElement('span');
    nameEl.className = 'qr-row__name';
    nameEl.textContent = producto.nombre || '';
    const skuEl = document.createElement('span');
    skuEl.className = 'qr-row__sku';
    skuEl.textContent = producto.sku || '';
    textWrap.appendChild(nameEl);
    textWrap.appendChild(skuEl);
    innerWrap.appendChild(imgEl);
    innerWrap.appendChild(textWrap);
    colProducto.appendChild(innerWrap);

    const colVariante = document.createElement('div');
    colVariante.className = 'qr-row__variant';
    renderVariantCell(colVariante, producto.variantes || [], producto.color || '', imgEl);

    const colQty = document.createElement('div');
    colQty.className = 'qr-row__qty';
    colQty.innerHTML = `
      <button type="button" class="qr-qty__btn qr-qty__minus">−</button>
      <input type="number" name="extra_qty[]" value="${producto.qty || 1}" min="${producto.qty || 1}" class="qr-qty__input">
      <button type="button" class="qr-qty__btn qr-qty__plus">+</button>
      <button type="button" class="qr-row__del" title="Quitar">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
      </button>
    `;

    row.appendChild(colProducto);
    row.appendChild(colVariante);
    row.appendChild(colQty);
    initRow(row);
    return row;
  }

  function precargarProductos() {
    const cotizacion = JSON.parse(localStorage.getItem('qr_cotizacion') || '[]');
    cotizacion.forEach(function(producto) {
      container.appendChild(crearFila(producto));
    });
    actualizarEstadoVacio();
  }

  precargarProductos();

  addMoreBtn?.addEventListener('click', function () {
    const catalogo = JSON.parse(localStorage.getItem('qr_catalogo') || '[]');
    if (!catalogo.length) {
      alert('Primero visita el catálogo corporativo para cargar los productos disponibles.');
      return;
    }

    const primer = catalogo[0];

    const nuevaFila = document.createElement('div');
    nuevaFila.className = 'qr-row';
    nuevaFila.dataset.dynamic = 'true';

    const imgEl = document.createElement('img');
    imgEl.src = primer.img || '';
    imgEl.alt = '';
    imgEl.style.cssText = 'width:52px;height:52px;object-fit:cover;border-radius:6px;border:1px solid #eee;flex-shrink:0;';

    const selectEl = document.createElement('select');
    selectEl.className = 'qr-select qr-product-selector';
    selectEl.style.cssText = 'font-weight:600;font-size:0.85rem;border:1px solid #ddd;border-radius:5px;padding:4px 6px;width:100%;';
    catalogo.forEach(function(p) {
      const opt = document.createElement('option');
      opt.textContent = p.nombre;
      opt.dataset.img = p.img || '';
      opt.dataset.sku = p.sku || '';
      opt.dataset.qtyMin = p.qtyMin || 1;
      opt.dataset.variantes = JSON.stringify(p.variantes || []);
      selectEl.appendChild(opt);
    });

    const skuEl = document.createElement('span');
    skuEl.className = 'qr-row__sku';
    skuEl.style.cssText = 'font-size:0.78rem;color:#888;display:block;margin-top:2px;';
    skuEl.textContent = primer.sku || '';

    const colProducto = document.createElement('div');
    colProducto.className = 'qr-row__product';
    const innerWrap = document.createElement('div');
    innerWrap.style.cssText = 'display:flex;gap:10px;align-items:flex-start;';
    const textWrap = document.createElement('div');
    textWrap.style.cssText = 'display:flex;flex-direction:column;gap:2px;flex:1;min-width:0;';
    textWrap.appendChild(selectEl);
    textWrap.appendChild(skuEl);
    innerWrap.appendChild(imgEl);
    innerWrap.appendChild(textWrap);
    colProducto.appendChild(innerWrap);

    const colVariante = document.createElement('div');
    colVariante.className = 'qr-row__variant';
    renderVariantCell(colVariante, primer.variantes || [], null, imgEl);

    const colQty = document.createElement('div');
    colQty.className = 'qr-row__qty';
    colQty.innerHTML = `
      <button type="button" class="qr-qty__btn qr-qty__minus">−</button>
      <input type="number" name="extra_qty[]" value="${primer.qtyMin || 1}" min="${primer.qtyMin || 1}" class="qr-qty__input">
      <button type="button" class="qr-qty__btn qr-qty__plus">+</button>
      <button type="button" class="qr-row__del" title="Quitar">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
      </button>
    `;

    selectEl.addEventListener('change', function() {
      const opt = this.options[this.selectedIndex];
      imgEl.src = opt.dataset.img;
      skuEl.textContent = opt.dataset.sku;
      const min = parseInt(opt.dataset.qtyMin || 1);
      colQty.querySelector('.qr-qty__input').value = min;
      colQty.querySelector('.qr-qty__input').min = min;
      let variantes = [];
      try { variantes = JSON.parse(opt.dataset.variantes || '[]'); } catch(e) {}
      renderVariantCell(colVariante, variantes, null, imgEl);
    });

    nuevaFila.appendChild(colProducto);
    nuevaFila.appendChild(colVariante);
    nuevaFila.appendChild(colQty);
    initRow(nuevaFila);
    container.appendChild(nuevaFila);
    actualizarEstadoVacio();
  });

  const form = document.getElementById('qr-form');
  const btn = document.getElementById('qr-submit-btn');
  const msg = document.getElementById('qr-message');

  form?.addEventListener('submit', async function (e) {
    e.preventDefault();
    let productos = '';
    container.querySelectorAll('.qr-row').forEach(function (row) {
      const selectorEl = row.querySelector('.qr-product-selector');
      const nombre = selectorEl
        ? selectorEl.options[selectorEl.selectedIndex]?.text
        : row.querySelector('.qr-row__name')?.textContent.trim();
      const qty = parseInt(row.querySelector('.qr-qty__input')?.value || 0);
      const varianteEl = row.querySelector('.qr-variant-input');
      const variante = varianteEl ? (varianteEl.value || '—').trim() : '—';
      if (qty > 0) productos += `• ${nombre} | ${variante} | Cantidad: ${qty}\n`;
    });

    if (!productos) {
      showMsg('Por favor agrega al menos un producto con cantidad mayor a 0.', 'error');
      return;
    }

    const data = new FormData(form);
    data.set('productos_seleccionados', productos);
    btn.disabled = true;
    btn.textContent = 'Enviando...';

    try {
      const res = await fetch('https://api.web3forms.com/submit', { method: 'POST', body: data });
      const json = await res.json();
      if (json.success) {
        showMsg('✅ ¡Solicitud enviada! Te contactaremos en menos de 24 horas hábiles.', 'success');
        form.reset();
        localStorage.removeItem('qr_cotizacion');
        container.innerHTML = '';
        actualizarEstadoVacio();
      } else {
        showMsg('Error al enviar. Por favor intenta nuevamente.', 'error');
      }
    } catch {
      showMsg('Error de conexión. Verifica tu internet e intenta de nuevo.', 'error');
    } finally {
      btn.disabled = false;
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg> ENVIAR SOLICITUD DE COTIZACIÓN';
    }
  });

  function showMsg(text, type) {
    msg.textContent = text;
    msg.className = 'qr-message qr-message--' + type;
    msg.style.display = 'block';
    msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});
